var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 2.88116C28.8978 3.37416 27.7093 3.7022 26.4684 3.84841C27.7393 3.08735 28.7122 1.88015 29.1752 0.444264C27.9868 1.14721 26.6671 1.66271 25.2687 1.93827C24.144 0.742315 22.545 0 20.7754 0C17.3769 0 14.6251 2.75369 14.6251 6.15034C14.6251 6.63022 14.6776 7.09885 14.7826 7.55061C9.66883 7.29193 5.13434 4.84379 2.09948 1.1191C1.57273 2.02637 1.26718 3.08735 1.26718 4.21207C1.26718 6.34529 2.35066 8.23107 4.00212 9.33142C2.99363 9.30142 2.04511 9.02025 1.21282 8.56473V8.64159C1.21282 11.624 3.33292 14.1133 6.15034 14.6757C5.63484 14.8163 5.08935 14.8932 4.52699 14.8932C4.12959 14.8932 3.74719 14.8519 3.36666 14.7826C4.15209 17.2251 6.42402 19.0059 9.11397 19.0584C7.00512 20.7098 4.35641 21.694 1.46963 21.694C0.971007 21.694 0.485504 21.664 0 21.6059C2.72932 23.3567 5.96288 24.3708 9.43639 24.3708C20.7529 24.3708 26.9464 14.9925 26.9464 6.86078C26.9464 6.59085 26.9408 6.32842 26.9295 6.06411C28.1311 5.2037 29.1733 4.11835 29.9981 2.88303L30 2.88116Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.1ab39f9c4a1c3da6fceee9411bfbad6f.svg";
export { ForwardRef as ReactComponent };